<template>
  <div class="wrapper flex-center-between">
    <div class="title pointer" @click="gotoLoginPage">
      <div class="logo" :class="{'logo-vip':isVipPage}">
        <img src="@/assets/imgs/icon5.png" alt="" v-if="!isVipPage">
        <!-- 会员页面用新的logo -->
        <img src="@/assets/imgs/member/logo.png" alt="" v-else>
      </div>
    </div>
    <div class="single-icon" title="返回备课列表页" v-show="showBackIcon" :class="{showReturnAIBK:isVipPage}">
      <div class="one-icon aiwrite" @click="goFiles"></div>
    </div>
<!--    <div class="exp-box" @click="goExp" v-show="showExpIcon" v-if="expString === '试用中'">-->
<!--      <img src="~@/assets/imgs/robot-icon.png" alt="">-->
<!--      <span>{{expString}}</span>-->
<!--    </div>-->
    <div class="btn-group">
      <div class="aibk-btn" v-if="isVipPage&&userID" @click="goFiles"></div>
      <div class="log-in-btn" v-if="!userID&&!isRulePage" @click="gotoLogin">登录</div>
      <div class="register-btn" v-if="!userID&&!isRulePage" @click="gotoReister">注册</div>
      <el-popover trigger="hover" placement="bottom" width="136" v-show="userName">
        <div class="padT10 padB10">
          <div class="person-item" @click="dialogVisible = true">
            <div class="one-icon info"></div>
            <div class="txtC">个人资料</div>
          </div>
          <div class="person-item" @click="goFiles">
            <div class="one-icon aiwrite"></div>
            <div class="txtC">智能备课</div>
          </div>
          <div class="person-item" @click="goAdmin" v-if="isAdmin">
            <div class="one-icon info"></div>
            <div class="txtC">产品管理</div>
          </div>
<!--          <div class="person-item" @click="goOrders">-->
<!--            <div class="one-icon info"></div>-->
<!--            <div class="txtC">个人中心</div>-->
<!--          </div>-->
          <div class="person-item" @click="feedbackDiaVis = true">
            <div class="one-icon feedback"></div>
            <div class="txtC">意见反馈</div>
          </div>
          <div class="person-item" @click="logout">
            <div class="one-icon logout"></div>
            <div class="txtC">退出登录</div>
          </div>
        </div>
        <div class="pointer head-title" slot="reference">
          <span>您好，{{userName}}</span>
          <img src="@/assets/imgs/tx.png" alt="" class="marL10">
        </div>
      </el-popover>
    </div>
<!--    <el-dialog width="750px" append-to-body custom-class="use-fb"-->
<!--               :visible.sync="expired" :close-on-click-modal="false"-->
<!--               :close-on-press-escape="false" :show-close="false">-->
<!--      <div slot="title" class="flex-center-center">-->
<!--        <i class="el-icon-message marR5" style="color: #333; font-weight: bold; font-size: 16px;"></i>-->
<!--        <span style="color: #333; font-weight: bold; font-size: 16px;">使用反馈</span>-->
<!--      </div>-->
<!--      <p class="msg-text marT20">产品体验已到期，十分感谢您体验知网AI智能备课~</p>-->
<!--      <p class="msg-text marB20">请留下您的宝贵意见，帮助我们完善产品和服务。</p>-->
<!--      <div class="rate-box">-->
<!--        <div>-->
<!--          <span>内容质量：</span>-->
<!--          <rate :starIndex="-1" ref="qualityRate"></rate>-->
<!--        </div>-->
<!--        <div>-->
<!--          <span>语言表达：</span>-->
<!--          <rate :starIndex="-1" ref="expressRate"></rate>-->
<!--        </div>-->
<!--        <div>-->
<!--          <span>专业性：</span>-->
<!--          <rate :starIndex="-1" ref="proRate"></rate>-->
<!--        </div>-->
<!--        <div>-->
<!--          <span>实用性：</span>-->
<!--          <rate :starIndex="-1" ref="useRate"></rate>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="input-box">-->
<!--        <div>-->
<!--          <el-input height="197px" type="textarea" placeholder="请输入您的意见/建议" resize="none"-->
<!--                    maxlength="200" show-word-limit v-model.trim="useContent"></el-input>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="radio-box">-->
<!--        <el-radio v-model="purpose" label="1">继续体验，稍后再说</el-radio>-->
<!--        <el-radio v-model="purpose" label="2">个人有购买意向</el-radio>-->
<!--        <el-radio v-model="purpose" label="3">请联系我，单位有购买意向</el-radio>-->
<!--      </div>-->
<!--      <div class="txtC">-->
<!--        <el-button type="primary" @click="submitUse">提交</el-button>-->
<!--      </div>-->
<!--    </el-dialog>-->
    <el-dialog width="460px" :visible.sync="feedbackDiaVis" :close-on-click-modal="false" append-to-body>
      <div slot="title" class="flex-center-center">
        <i class="el-icon-message marR5" style="color: #333; font-weight: bold; font-size: 16px;"></i>
        <span style="color: #333; font-weight: bold; font-size: 16px;">意见反馈</span>
      </div>
      <div class="fb-body">
        <div>
          <el-input type="textarea" placeholder="请输入您的意见/建议" resize="none"
                    maxlength="200" show-word-limit v-model.trim="fbContent"></el-input>
        </div>
        <div class="marT5 marB5">
          上传图片({{fileList.length}}/5)
        </div>
        <div class="upload-box">
          <el-upload
              :class="{'hide-btn': fileList.length >= 5}"
              action="#"
              :auto-upload="false"
              :file-list="fileList"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-change="handleChange"
              :on-exceed="handleExceed"
              list-type="picture-card" accept="image/png, image/jpeg" multiple :limit="5">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="picVis" append-to-body title="预览图片" :close-on-click-modal="false">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </div>
        <div class="marT5 marB5" style="color: #0075ff;">
          支持上传的图片格式为jpg、png格式
        </div>
      </div>
      <div class="txtC">
        <el-button type="primary" @click="submitFb">提交</el-button>
        <el-button @click="cancelFb">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog width="800px" :visible.sync="dialogVisible" title="设置个人资料" :close-on-click-modal="false" append-to-body>
      <div class="dialog-content">
        <div class="tips">为了提供更加精准的服务，建议您先完善自己的个人信息</div>
        <div class="dialog-item txtC">
          <span><span class="red">*</span>学段</span>
          <el-select placeholder="请选择学段" class="self-select" v-model="pickedSection" @change="changeSection">
            <el-option
                v-for="item in sections"
                :key="item.sectionId"
                :label="item.sectionName"
                :value="item.sectionId">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-item txtC">
          <span><span class="red">*</span>年级</span>
          <el-select placeholder="请选择年级" class="self-select" v-model="pickedGrade">
            <el-option
                v-for="item in grades"
                :key="item.gradeId"
                :label="item.gradeName"
                :value="item.gradeId">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-item txtC">
          <span><span class="red">*</span>学科</span>
          <el-select placeholder="请选择学科" class="self-select" v-model="pickedSubject" @change="changeSubject">
            <el-option
                v-for="item in subjects"
                :key="item.subjectId"
                :label="item.subjectName"
                :value="item.subjectId">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-item txtC">
          <span><span class="red">*</span>教材版本</span>
          <el-select placeholder="请选择教材版本" class="self-select" v-model="pickedBookVersion" @change="changeBookVersion">
            <el-option
                v-for="item in bookVersions"
                :key="item.textBookVersionId"
                :label="item.textBookVersionName"
                :value="item.textBookVersionId">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-item txtC">
          <span><span class="red">*</span>分册</span>
          <el-select placeholder="请选择分册" class="self-select" v-model="pickedBook">
            <el-option
                v-for="item in books"
                :key="item.id"
                :label="item.bookName"
                :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="marT20 txtC">
        <el-button type="primary" @click="confirmInfo">确定</el-button>
        <el-button @click="cancelInfo">取消</el-button>
      </div>
    </el-dialog>
    <!-- 登录注册 -->
    <login-dialog ref="loginRef" @initProject="loginInit"></login-dialog>
  </div>
</template>
<script>
import {jumptoLogin, setLID, mobileFormatCheck, isCnkiEnv, isExpire} from "@/utils/tools";
import {mapMutations, mapState} from "vuex";
import rate from "@/components/rate.vue";
import loginDialog from "@/components/loginAndRegister.vue";
export default {
  name: "customHeader",
  data() {
    return {
      dialogVisible: false,
      expDiaVis: false,
      pickedSection: '',
      pickedGrade: '',
      pickedSubject: '',
      pickedBookVersion: '',
      pickedBook: '',
      grades:[],
      subjects: [],
      bookVersions: [],
      books: [],
      expString: '体验',
      agree: false,
      expSectionList: [
        {value: "学前",label: "学前"},
        {value: "小学",label: "小学"},
        {value: "初中",label: "初中"},
        {value: "高中",label: "高中"},
        {value: "其他",label: "其他"},
      ],
      expSection: '',
      expSubjectList: [
        {value: "语文", label: "语文"},
        {value: "数学", label: "数学"},
        {value: "英语", label: "英语"},
        {value: "思想政治（道德与法治）", label: "思想政治（道德与法治）"},
        {value: "历史", label: "历史"},
        {value: "地理", label: "地理"},
        {value: "物理", label: "物理"},
        {value: "化学", label: "化学"},
        {value: "生物", label: "生物"},
        {value: "信息技术", label: "信息技术"},
        {value: "心理健康", label: "心理健康"},
        {value: "劳动技术", label: "劳动技术"},
        {value: "音乐", label: "音乐"},
        {value: "体育", label: "体育"},
        {value: "美术", label: "美术"},
        {value: "其他", label: "其他"}
      ],
      expSubject: '',
      expName: "",
      expPhone: "",
      expDepart: '',
      queNum: 0,
      feedbackDiaVis: false,
      fbContent: '',
      useContent: '',
      fileList: [],
      picVis: false,
      dialogImageUrl: '',
      expired: false,
      purpose: '0'
    }
  },
  components: {
    rate,
    loginDialog
  },
  watch: {
    dialogVisible(value) {
      if (value) {
        if (!this.pickedSection) {
          this.pickedSection = this.userInfoExtra.sectionId;
          if (this.pickedSection) {
            this.changeSection(this.pickedSection, true);
          }
        }
      } else { // 在登录页确认信息后跳转文件管理页面
        if (this.$route.path.includes('login')) {
          this.$router.push({
            path: '/fileManager'
          });
        }
      }
    },
    userExp() {
      this.setExp();
    }
  },
  computed: {
    ...mapState(['userName', "userID", 'sections', "userInfoExtra", "isAdmin", "userExp", "userInfo", "isOrdered"]),
    showExpIcon() {
      if (this.$route.path.includes('fileManager') === false) return false;
      if (this.isOrdered) {
        if (this.userExp === null) {
          return false;
        } else if (this.userExp) {
          if (this.userExp.status === 2) { // 审核通过
            if (isExpire(this.userExp.endTime)) {
              return false;
            } else {
              return true;
            }
          } else { // 排队中
            return true;
          }
        }
      } else {
        return true;
      }
    },
    showBackIcon() {
      // return this.$route.path.includes('admin');
      return ["/admin","/expAudit","/useFb","/ideaFb","/userLog","/logStat","/fileQuery","/memberService"].includes(this.$route.path)
    },
    showVIpIcon(){
       return !this.$route.path.includes('rule');
    },
    isVipPage(){
      return !!this.$route.path.includes('vip');
    },
    isRulePage(){
      return !!this.$route.path.includes('rule');
    },
    expSubmitShow() {
      return this.expString === '申请体验';
    },
    expQueShow() {
      return this.queNum >= 1;
    },
    expSuccessShow() {
      return this.expString === '试用中';
    },
  },
  methods: {
    ...mapMutations(['changeUserInfoExtra']),
    // goOrders(){
    //   if(this.$route.path == "/receipt"){
    //     return;
    //   }
    //   this.$router.push({
    //     path: '/receipt'
    //   });
    // },
    setExp() {
      this.expired = false;
      if (this.userExp === null) {
        this.expString = '申请体验';
      } else if (this.userExp) {
        if (this.userExp.status === 2) { // 审核通过
          if (isExpire(this.userExp.endTime)) {
            this.expString = "申请体验";
            this.expired = !(this.userInfo.useFeedBackList && this.userInfo.useFeedBackList.length) && this.$route.path.includes('fileManager');
          } else {
            this.expString = "试用中";
          }
        } else { // 排队中
          this.getQueNum();
        }
      }
    },
    submitUse() {
      let qualityRateNum = this.$refs.qualityRate.clickPicked;
      let expressRateNum = this.$refs.expressRate.clickPicked;
      let proRateNum = this.$refs.proRate.clickPicked;
      let useRateNum = this.$refs.useRate.clickPicked;
      if (qualityRateNum === -1) return this.$message.warning('请给内容质量评分！');
      if (expressRateNum === -1) return this.$message.warning('请给语言表达评分！');
      if (proRateNum === -1) return this.$message.warning('请给专业性评分！');
      if (useRateNum === -1) return this.$message.warning('请给实用性评分！');
      if (!this.useContent) return this.$message.warning('请输入您的意见/建议！');
      if (this.purpose === '0') return this.$message.warning('请选择您的意向！');
      this.expired = false;
      this.requestPost('/teachplan/user/addUseFeedBack', {
        contentStar: qualityRateNum + 1,
        languageStar: expressRateNum + 1,
        professionalStar: proRateNum + 1,
        useFulStar: useRateNum + 1,
        suggest: this.useContent,
        purpose: Number(this.purpose),
        experienceId: this.userExp.id
      }, (data) => {
        this.$message.success('提交成功！');
        this.$store.dispatch('getUserInfo');
      })
    },
    submitFb() {
      if (!this.fbContent) return this.$message.warning('请输入您的意见/建议！');
      const formData = new FormData();
      formData.append('suggestInfo', this.fbContent);
      this.fileList.forEach((item) => {
        formData.append('file', item.raw);
      })
      let loading = this.$loading({});
      this.axios.post('/teachplan/user/addSuggest', formData).then((res) => {
        if (res && res.code === 200) {
          this.$message.success('反馈成功！');
          this.clearFb();
          this.feedbackDiaVis = false;
        } else {
          this.$message.error('请求出错！');
        }
      }).catch((err) => {
        this.showErrorMsg(err);
      }).finally(() => {
        loading.close();
      })
    },
    clearFb() {
      this.fbContent = '';
      this.fileList = [];
    },
    cancelFb() {
      this.clearFb();
      this.feedbackDiaVis = false;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.picVis = true;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleChange(file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.warning('上传图片大小不能超过 2MB!');
        fileList.splice(-1,1);
      } else {
        this.fileList = fileList;
      }
    },
    handleExceed(file, fileList) {
      this.$message.warning('最多只能选择5张图片！');
    },
    getQueNum() {
      this.requestGet('/teachplan/user/experienceSortNum', null, (data) => {
        if (data >= 1) {
          this.expString = `等待中`;
          this.queNum = data;
        }
      })
    },
    checkInput() {
      if (!this.expName) {
        this.$message.warning('请输入姓名！');
        return false;
      }
      if (!this.expPhone) {
        this.$message.warning('请输入联系方式！');
        return false;
      }
      if (!mobileFormatCheck(this.expPhone)) {
        this.$message.warning('手机号码格式错误！');
        return false;
      }
      if (!this.expSection) {
        this.$message.warning('请选择学段！');
        return false;
      }
      if (!this.expSubject) {
        this.$message.warning('请选择学科！');
        return false;
      }
      if (!this.expDepart) {
        this.$message.warning('请输入所在单位！');
        return false;
      }
      return true;
    },
    submitExp() {
      if (!this.checkInput()) return;
      if (!this.agree) return this.$message.warning('请阅读并接受协议！');
      this.expDiaVis = false;
      this.requestPost(`/teachplan/user/addExperience`, {
        userId: this.userID,
        realName: this.expName,
        mobile: this.expPhone,
        company: this.expDepart,
        sectionName: this.expSection,
        subjectName: this.expSubject,
      }, (data) => {
        if (data === 1) {
          this.clearExp();
          this.$store.dispatch('getUserInfo');
        } else {
          this.$message.error('申请体验失败！');
        }
      });
    },
    clearExp() {
      this.expName = '';
      this.expPhone = '';
      this.expSection = '';
      this.expSubject = '';
      this.expDepart = '';
      this.agree = false;
    },
    cancelExp() {
      this.expDiaVis = false;
      this.clearExp();
    },
    checkMobile() {
      if (!this.expPhone) return;
      let res = mobileFormatCheck(this.expPhone);
      if (res === false) this.$message.warning('手机号码格式错误！');
    },
    goExp() {
      this.expDiaVis = true;
    },
    changeSection(sectionId, isManual) {
      this.pickedSubject = '';
      this.pickedGrade = '';
      this.pickedBookVersion = '';
      this.pickedBook = '';
      this.bookVersions = [];
      this.books = [];
      this.getSubjects(sectionId, isManual);
      this.getGrades(sectionId, isManual);
    },
    changeSubject(subjectId, isManual) {
      this.pickedBookVersion = '';
      this.pickedBook = '';
      this.books = [];
      this.bookVersions = [];
      this.getBookVersions(subjectId, isManual);
    },
    changeBookVersion(bvId, isManual) {
      this.pickedBook = '';
      this.books = [];
      this.getBooks(bvId, isManual);
    },
    getSubjects(sectionId, isManual) {
      this.axios.get(`/teachplan/common/subjects?sectionId=${sectionId}`).then((res) => {
        if (res && res.code === 200) {
          this.subjects = res.data || [];
          if (isManual) {
            this.pickedSubject = this.userInfoExtra.subjectId;
            this.changeSubject(this.pickedSubject, true)
          }
        } else {
          console.log(res);
          this.$message.error('请求出错！');
        }
      }).catch((err) => {
        this.showErrorMsg(err);
      })
    },
    getGrades(sectionId, isManual) {
      this.axios.get(`/teachplan/common/grades?sectionId=${sectionId}`).then((res) => {
        if (res && res.code === 200) {
          this.grades = res.data || [];
          if (isManual) {
            this.pickedGrade = this.userInfoExtra.gradeId;
          }
        } else {
          console.log(res);
          this.$message.error('请求出错！');
        }
      }).catch((err) => {
        this.showErrorMsg(err);
      })
    },
    getBookVersions(subjectId, isManual) {
      this.axios.get(`/teachplan/common/textBookVersions?subjectId=${subjectId}`).then((res) => {
        if (res && res.code === 200) {
          this.bookVersions = res.data || [];
          if (isManual) {
            this.pickedBookVersion = this.userInfoExtra.textBookVersionId;
            this.changeBookVersion(this.pickedBookVersion, true);
          }
        } else {
          console.log(res);
          this.$message.error('请求出错！');
        }
      }).catch((err) => {
        this.showErrorMsg(err);
      })
    },
    getBooks(bvId, isManual) {
      let sectionName = '',
          subjectName = '',
          bookVersionName = '';
      this.sections.forEach((item) => {
        if (item.sectionId === this.pickedSection) sectionName = item.sectionName;
      });
      this.subjects.forEach((item) => {
        if (item.subjectId === this.pickedSubject) subjectName = item.subjectName;
      });
      this.bookVersions.forEach((item) => {
        if (item.textBookVersionId === this.pickedBookVersion) bookVersionName = item.textBookVersionName;
      });
      this.axios.get(`/teachplan/common/books?sectionName=${sectionName}&subjectName=${subjectName}&textBookVersionName=${bookVersionName}`).then((res) => {
        if (res && res.code === 200) {
          this.books = res.data || [];
          if (isManual) {
            this.pickedBook = this.userInfoExtra.bookId;
          }
        } else {
          console.log(res);
          this.$message.error('请求出错！');
        }
      }).catch((err) => {
        this.showErrorMsg(err);
      })
    },
    cancelInfo() {
      this.pickedSection = '';
      this.dialogVisible = false;
    },
    confirmInfo() {
      if (!(this.pickedSection && this.pickedSubject && this.pickedGrade && this.pickedBookVersion !== '' && this.pickedBook !== '')) {
        return this.$message.warning('必选项不可为空！');
      }
      this.axios.post(`/teachplan/user/editExtendedInfo`, {
        sectionId: this.pickedSection,
        subjectId: this.pickedSubject,
        gradeId: this.pickedGrade,
        textBookVersionId: this.pickedBookVersion,
        bookId: this.pickedBook
      }).then((res) => {
        if (res && res.code === 200) {
          this.$message.success('设置成功！');
          this.getUserInfoExtra();
          this.dialogVisible = false;
        } else {
          console.log(res);
          this.$message.error('请求出错！');
        }
      }).catch((err) => {
        this.showErrorMsg(err);
      })
    },
    getUserInfoExtra() {
      this.axios.get('/teachplan/user/extendedInfo').then((res) => {
        if (res && res.code === 200) {
          this.changeUserInfoExtra(res.data || {});
        } else {
          console.log(res);
          this.$message.error('请求出错！');
        }
      }).catch((err) => {
        this.showErrorMsg(err);
      })
    },
    logout() {
      this.axios.get('/teachplan/login/signOut').then((res) => {
        setLID('');
        if(location.href.includes('/legal')){
          this.$store.commit('changeUserInfo', {
            id: "",
            name: "",
            role:  0,
            isAdmin:false,
            exp: null,
            userInfo:{}
          })
        }else{
          jumptoLogin();
        }
      }).catch((err) => {
        this.showErrorMsg(err);
      })
    },
    login() {
      this.$emit('login');
    },
    goFiles() {
      if (this.$route.path.includes('fileManager')) return;
      this.$router.push({
        path: '/fileManager'
      });
    },
    goAdmin() {
      if (this.$route.path.includes('admin')) return;
      this.$router.push({
        path: '/admin'
      });
    },
    gotoLoginPage() {
      this.$router.push({
        path: '/login'
      });
    },
    gotoLogin(){
      this.$refs.loginRef.curType = "login";
      this.$refs.loginRef.showLoginDia = true;
    },
    gotoReister(){
      this.$refs.loginRef.curType = "reg";
      this.$refs.loginRef.showLoginDia = true;
    },
    loginInit(){
      this.$parent.initProject();
    }
  },
  created() {
    this.setExp();

  },
  mounted() {
  }
}
</script>


<style scoped>
  .wrapper {
    height: 0;
    overflow: hidden;
    background-color: #fff;
    box-shadow: 0px 3px 20px 0px rgba(198, 211, 227, 0.5);
    padding: 0 20px;
    position: relative;
    z-index: 1;
  }
  .wrapper .title .logo img:first-child {
    width: 34px;
    height: 34px;
  }
  .wrapper .title .logo {
    background: url("~@/assets/imgs/logo2.png") left center no-repeat;
    width: 213px;
  }
  .wrapper .title .logo-vip{
    background: none;
    display: flex;
    align-items: center;
  }
  .wrapper .title .logo.logo-vip img:first-child {
    width:173px;
    height:21px;
    margin-right:10px;
  }
  .wrapper .single-icon {
    margin-right: auto;
    margin-left: 20px;
    cursor: pointer;
  }
  .single-icon:hover .aiwrite {
    background: url(~@/assets/imgs/aiwriteActive.svg) center center no-repeat;
  }
  .exp-box {
    background-image: linear-gradient(90deg, #0075ff 0%, #99a5f7 100%);
    border-radius: 6px;
    color: #ffffff;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    margin-left: auto;
    margin-right: 20px;
    line-height: 28px;
    padding-right: 13px;
    padding-left: 28px;
    cursor: pointer;
    position: relative;
  }
  .exp-success-box {
    background-image: linear-gradient(90deg, #0075ff 0%, #99a5f7 100%);
    border-radius: 6px;
    color: #ffffff;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    position: relative;
    width: 400px;
    margin: 40px auto 30px;
    box-sizing: border-box;
    padding: 10px 0 10px 36px;
  }
  .exp-success-box.success {
    padding: 0 0 0 36px;
    line-height: 45px;
    white-space: nowrap;
  }
  .exp-success-box.success p span {
    color: #ffdc4f;
    text-decoration: underline;
    cursor: pointer;
  }
  .exp-success-box>p:first-child {
    font-size: 16px;
    font-weight: bold;
  }
  .exp-success-box img {
    position: absolute;
    left: -40px;
    top: -11px;
  }
  .exp-success-box.success img {
    top: -20px;
  }
  .exp-box img {
    position: absolute;
    left: -19px;
    top: -5px;
  }
  .head-title {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .person-item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    cursor: pointer;
    color: #666;
  }
  .one-icon {
    width: 18px;
    height: 18px;
  }
  .person-item .txtC {
    width: 75px;
  }
  .person-item:hover {
    color: #0075ff;
    background-color: #f4f7fb;
  }
  .info {
    background: url(~@/assets/imgs/info.svg) center center no-repeat;
  }
  .person-item:hover .info {
    background: url(~@/assets/imgs/infoActive.svg) center center no-repeat;
  }
  .aiwrite {
    background: url(~@/assets/imgs/aiwrite.svg) center center no-repeat;
  }
  .person-item:hover .aiwrite {
    background: url(~@/assets/imgs/aiwriteActive.svg) center center no-repeat;
  }
  .feedback {
    background: url(~@/assets/imgs/feedback.svg) center center no-repeat;
  }
  .person-item:hover .feedback {
    background: url(~@/assets/imgs/feedbackActive.svg) center center no-repeat;
  }
  .logout {
    background: url(~@/assets/imgs/logout.svg) center center no-repeat;
  }
  .person-item:hover .logout {
    background: url(~@/assets/imgs/logoutActive.svg) center center no-repeat;
  }
  .tips {
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
    color: #0075ff;
    padding-left: 37px;
    background: url("~@/assets/imgs/tips.png") 15px center no-repeat #eaf2ff;
    margin: 0 20px 20px;
  }
  .dialog-item {
    padding: 10px 0;
  }
  .dialog-item>span {
    display: inline-block;
    width: 100px;
    text-align: right;
    margin-right: 10px;
  }
  .dialog-item .self-select {
    width: 480px;
  }
  .exp-rule {
    padding: 10px 40px 0;
    height: 370px;
    box-sizing: border-box;
    background-color: #f2f6fb;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 26px;
    letter-spacing: 0px;
    color: #000;
    overflow: auto;
  }
  @media screen and (max-height: 700px) {
    .exp-rule {
      height: 250px;
    }
  }
  .exp-rule p {
    text-indent: 2em;
    margin-bottom: 20px;
  }
  .exp-rule p:first-child {
    text-indent: 0;
  }
  .exp-info {
    padding: 20px 50px 20px 40px;
  }
  .exp-info .el-input,
  .exp-info .el-select {
    width: 220px;
  }
  .exp-info .long-input {
    width: 532px;
  }
  .exp-info .el-input >>> .el-input__inner,
  .exp-info .el-select >>> .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
  .exp-info .el-select >>> .el-input__icon {
    line-height: 32px;
  }
  .exp-agree {
    padding-left: 60px;
    margin-bottom: 10px;
  }
  .exp-agree a {
    color: #0075ff;
  }
  .fb-body {
    padding: 20px 40px;
    box-sizing: border-box;
    border-top: 1px solid #f5f5f5;
  }
  .fb-body>div:first-child >>> .el-textarea__inner {
    height: 200px;
  }
  .upload-box >>> .el-upload--picture-card {
    width: 60px;
    height: 60px;
    line-height: 64px;
  }
  .upload-box .hide-btn >>> .el-upload--picture-card {
    display: none;
  }
  .upload-box >>> .el-upload-list--picture-card .el-upload-list__item {
    width: 60px;
    height: 60px;
  }
  .upload-box >>> .el-upload-list--picture-card .el-upload-list__item-actions span+span {
    margin-left: 5px;
  }
  .upload-box >>> .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    object-fit: cover;
  }
  .el-dialog__wrapper >>> .use-fb {
    background: url("~@/assets/imgs/fb-bg.png") center center no-repeat;
    background-size: cover;
  }
  .msg-text {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 0px;
    color: #333333;
    text-align: center;
  }
  .rate-box {
    margin: 0 100px;
    background-color: #fff;
    padding: 30px;
    border-radius: 8px;
  }
  .input-box {
    margin: 20px 100px;
  }
  .input-box >>> .el-textarea__inner {
    height: 97px;
  }
  .rate-box>div {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
  }
  .rate-box>div>span:first-child {
    text-align: right;
    width: 80px;
    margin-right: 10px;
  }
  .radio-box {
    margin: 0 100px 28px;
  }
  .showReturnAIBK{
    visibility: hidden;
  }
  .btn-group{
    display:flex;
    align-items: center;
  }
  .aibk-btn{
    width: 120px;
    height: 60px;
    margin-right:20px;
    cursor:pointer;
    background: url(~@/assets/imgs/member/btn-1.png) center center no-repeat;
  }

  /* 登录注册 */
  .show-head .log-in-btn {
  width: 76px;
  height: 36px;
  background-color: #0075ff;
  border-radius: 4px;
  color: #fff;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
  margin-right: 10px;
}
.show-head .register-btn {
  width: 76px;
  height: 36px;
  background-color: #EEF4FF;
  border-radius: 4px;
  color: #0075ff;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
}
</style>
